import { restAxios } from './httpClient';
import { stripBlankParams } from '../helpers/queryParams';

const EDITIONS_PATH = '/v1/licensing/editions';

/*
 * Paging fires a request per gesture, and the responses can come back out of order. Aborting the
 * in-flight read keeps the table showing the latest page rather than whichever response happened
 * to land last.
 */
let getEditionsController;

export const getEditions = (queryParams) => {
	getEditionsController?.abort();

	getEditionsController = new AbortController();
	const searchParams = new URLSearchParams(stripBlankParams(queryParams)).toString();

	return restAxios.get(`${EDITIONS_PATH}?${searchParams}`, {
		signal: getEditionsController.signal
	});
};

export const getEdition = (id) => {
	return restAxios.get(`${EDITIONS_PATH}/${id}`);
};

/*
 * Answers with a job id rather than the edition, so the write is not finished when the promise
 * resolves - the caller has to poll the job. See the thunks in data/editions.
 */
export const updateEdition = (id, payload) => {
	return restAxios.patch(`${EDITIONS_PATH}/${id}`, payload);
};

/*
 * Previews the grants an edition gives for a start and a duration, one row per license of the edition, in the shape
 * the product form saves. It writes nothing (SYN-3464). `query` is built by helpers/editionGrants.js.
 */
export const getEditionGrants = (query) => {
	const searchParams = new URLSearchParams(stripBlankParams(query)).toString();

	return restAxios.get(`/v1/licensing/edition-grants?${searchParams}`);
};
